export default "__VITE_ASSET__Cht_u$lZ__"